import { useCallback, useState } from 'react';

export const MAT_VIEW = 'mat';
export const TABLE_VIEW = 'table';

const STORAGE_KEY = 'pokemon.boardView';

function storedView() {
  try {
    const view = window.localStorage.getItem(STORAGE_KEY);
    return view === TABLE_VIEW ? TABLE_VIEW : MAT_VIEW;
  } catch (e) {
    // Private browsing or blocked storage: the mat is the default anyway.
    return MAT_VIEW;
  }
}

/** Which board this device shows, remembered between visits. The mat is the default. */
export function useBoardView() {
  const [view, setView] = useState(storedView);

  const changeView = useCallback((next) => {
    setView(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // Not remembered, but the switch still applies for this visit.
    }
  }, []);

  return [view, changeView];
}
